import { render } from "./AppBottomSheet.vue?vue&type=template&id=389f62f0&scoped=true"
import script from "./AppBottomSheet.vue?vue&type=script&lang=js"
export * from "./AppBottomSheet.vue?vue&type=script&lang=js"

import "./AppBottomSheet.vue?vue&type=style&index=0&id=389f62f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389f62f0"]])

export default __exports__